import { gsap } from 'gsap'
import { CSSRulePlugin } from 'gsap/CSSRulePlugin'
import { GSDevTools } from 'gsap/GSDevTools'

const lib = require('../library')
const prod = process.env.NODE_ENV === 'production'

gsap.registerPlugin(CSSRulePlugin, GSDevTools)

export default class PageHomepage {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.heroArea = this.el.querySelector('[data-homepage-hero]')
  }

  init() {
    console.log('homepage is loading')
    if (this.heroArea) {
      this.handleHomeHeroAni()
    }
  }

  handleHomeHeroAni() {
    const elems = this.heroArea.querySelectorAll('[data-anim]')
    const events = this.heroArea.querySelector('[data-anim-events]')
    const t1 = gsap.timeline({
      defaults: { duration: 1.5, opacity: 0, ease: 'power3.out' },
      id: 'HomeHero',
    })

    t1.from(this.heroArea, { autoAlpha: 0 })
    t1.from(
      elems,
      {
        opacity: 0,
        y: '-=30',
        stagger: 0.3,
      },
      '-=<.2',
    )
    t1.from(
      events,
      {
        opacity: 0,
        y: '+=50',
      },
      '-=<.3',
    )
  }
}
